export enum ProductFlagKey {
  FaultInjection = 'hasProductFI',
  ReliabilityManagement = 'hasProductRM',
  FailureFlags = 'hasProductFF'
}

export enum LimitTrackingPeriod {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

export interface CompanyEntitlementResponse {
  company_id: string
  created_at: string // date string
  end: string // date string
  internal: boolean
  strict: boolean
  has_agent_billing: boolean // when has_agent_billing is false, billing type based off of attack targets
  has_trial_banners: boolean
  product_flags: Record<ProductFlagKey, boolean>
  limits: {
    limitUsers: number
    limitServices: number
    limitAgents: number // aka clients limit
    limitTeams: number
    limitTargets: number
  }
  targets_tracking_period: LimitTrackingPeriod
}

// todo: EN-6051 deprecate
export enum ContractTier {
  Free = 'Free',
  Enterprise = 'Enterprise',
  RMSubscription = 'RMSubscription' // this does not have a space - do not confuse with the display value above
}

// todo: EN-6051 deprecate
export type ContractItem = {
  company_id: string
  start: string
  end?: string
  is_trial: boolean
  has_reliability_management: boolean
  has_fault_injection: boolean
  limit_policy?: string
  tier: ContractTier
  contract_id: string
  pricing_plan_id?: string
  pricing_plan_name?: PricingPlanTier
  pricing_plan_overrides?: string
  pricing_plan_add_ons_count?: number
  created_at: string
  updated_at: string
}

// todo: EN-6051 deprecate
export type Contract = {
  contract_id: string
  items: ContractItem[]
}
